import React from 'react';

interface WelcomeScreenProps {
  displayName: string;
  email: string | null;
  userId: any;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ displayName, email, userId }) => {
  return (
    <div className="welcome-screen">
      <div className="welcome-logo">
        <img src="/2logo192.png" alt="Company Logo" />
      </div>

      <h1 className="welcome-title">
        Hello, {displayName || (email ? email.split('@')[0] : '') || userId || 'there'}
      </h1>

      <p className="welcome-subtitle">How can I help you today?</p>
    </div>
  );
};

export default WelcomeScreen;